// ===================================================================
// THIS FILE WAS AUTO GENERATED DO NOT EDIT IMPLACE
// ===================================================================
/* eslint-disable @typescript-eslint/no-duplicate-enum-values */

/**
 * JobsInstance status
 */
export enum ECpmCJobsInstanceStatusApiEnum {
    UNREACHABLE = 'UNREACHABLE',
    INCOMPATIBLE = 'INCOMPATIBLE',
    IDLE = 'IDLE',
    ACTIVE = 'ACTIVE',
    CONFLICT = 'CONFLICT'
}

/**
 * Enum value type by enum value (AKA Reversed enum)
 */
export const RECpmCJobsInstanceStatusApiEnum = Object.fromEntries(
    Object.entries(ECpmCJobsInstanceStatusApiEnum)
        .map(([key, value]) => [
            value,
            key as ECpmCJobsInstanceStatusApiEnum
        ])
);

